import { useState } from "react";
import { useNavigate } from "react-router-dom";

export default function LoginPage() {
  const navigate = useNavigate();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setError("");
    if (!username || !password) {
      setError("Kullanıcı adı ve şifre gereklidir.");
      return;
    }
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
      navigate("/dashboard");
    }, 1200);
  };

  return (
    <div className="min-h-screen flex flex-col lg:flex-row">
      {/* Left - Brand Panel */}
      <div
        className="hidden lg:flex lg:w-[55%] relative flex-col justify-between p-12"
        style={{
          background: "linear-gradient(135deg, #0B1120 0%, #0d1f3c 40%, #0f2a1a 100%)",
        }}
      >
        {/* Background image overlay */}
        <div
          className="absolute inset-0 opacity-10"
          style={{
            backgroundImage: `url('https://readdy.ai/api/search-image?query=abstract%20education%20technology%20pattern%20with%20books%20graduation%20caps%20communication%20bubbles%20geometric%20shapes%20soft%20white%20lines%20on%20dark%20navy%20background%20minimal%20modern%20digital%20illustration%20educational%20SaaS%20dashboard%20aesthetic&width=900&height=1100&seq=login-bg-001&orientation=portrait')`,
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
        />

        {/* Green accent dots */}
        <div className="absolute top-32 right-20 w-3 h-3 rounded-full bg-[#25D366] opacity-60 animate-pulse"></div>
        <div className="absolute top-48 right-32 w-2 h-2 rounded-full bg-[#25D366] opacity-40"></div>
        <div className="absolute bottom-48 left-16 w-4 h-4 rounded-full bg-[#25D366]/30"></div>

        <div className="relative z-10">
          <div className="flex items-center gap-3 mb-16">
            <div className="w-11 h-11 flex items-center justify-center bg-[#25D366] rounded-xl">
              <i className="ri-whatsapp-line text-white text-xl"></i>
            </div>
            <div>
              <p className="text-white font-bold text-base">Veli İletişim</p>
              <p className="text-white/40 text-xs">Hatırlatma Paneli</p>
            </div>
          </div>

          <h2 className="text-white text-4xl font-bold leading-tight mb-6">
            Veli ve Öğrenci<br />
            <span className="text-[#25D366]">Yönetimini</span><br />
            Kolaylaştırın
          </h2>
          <p className="text-white/60 text-base leading-relaxed max-w-md">
            240+ öğrencinin ödeme hatırlatmalarını, referans takibini ve WhatsApp iletişimini tek panelden organize edin.
          </p>
        </div>

        {/* Stats */}
        <div className="relative z-10 grid grid-cols-3 gap-4 mt-12">
          {[
            { value: "243+", label: "Aktif Öğrenci" },
            { value: "1.2K+", label: "Aylık Mesaj" },
            { value: "%96", label: "Memnuniyet" },
          ].map((stat, i) => (
            <div key={i} className="bg-white/5 rounded-2xl p-4 border border-white/10">
              <p className="text-[#25D366] text-2xl font-bold">{stat.value}</p>
              <p className="text-white/50 text-xs mt-1">{stat.label}</p>
            </div>
          ))}
        </div>

        {/* Feature list */}
        <div className="relative z-10 mt-8 space-y-3">
          {[
            "Otomatik WhatsApp hatırlatmaları",
            "Ödeme ve taahhüt takibi",
            "Kampanya yönetimi",
          ].map((f, i) => (
            <div key={i} className="flex items-center gap-3">
              <div className="w-5 h-5 flex items-center justify-center rounded-full bg-[#25D366]/20">
                <i className="ri-check-line text-[#25D366] text-xs"></i>
              </div>
              <span className="text-white/60 text-sm">{f}</span>
            </div>
          ))}
        </div>
      </div>

      {/* Right - Login Form */}
      <div className="flex-1 flex items-center justify-center bg-gray-50 p-6">
        <div className="w-full max-w-md">
          {/* Mobile logo */}
          <div className="lg:hidden flex items-center gap-3 mb-8 justify-center">
            <div className="w-10 h-10 flex items-center justify-center bg-[#25D366] rounded-xl">
              <i className="ri-whatsapp-line text-white text-lg"></i>
            </div>
            <div>
              <p className="text-gray-900 font-bold text-sm">Veli İletişim ve Hatırlatma Paneli</p>
            </div>
          </div>

          <div className="bg-white rounded-3xl shadow-sm border border-gray-100 p-8 md:p-10">
            <div className="mb-8">
              <h1 className="text-2xl font-bold text-gray-900 mb-2">Hoş Geldiniz</h1>
              <p className="text-gray-500 text-sm leading-relaxed">
                Öğrenci, veli, ödeme ve WhatsApp hatırlatma süreçlerinizi tek panelden yönetin.
              </p>
            </div>

            <form onSubmit={handleSubmit} className="space-y-5">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1.5">
                  Kullanıcı Adı
                </label>
                <div className="relative">
                  <div className="absolute left-3.5 top-1/2 -translate-y-1/2 w-5 h-5 flex items-center justify-center text-gray-400">
                    <i className="ri-user-line text-base"></i>
                  </div>
                  <input
                    type="text"
                    value={username}
                    onChange={(e) => setUsername(e.target.value)}
                    placeholder="Kullanıcı adınızı girin"
                    className="w-full pl-10 pr-4 py-3 text-sm border border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-[#25D366]/30 focus:border-[#25D366] bg-gray-50 transition-all"
                  />
                </div>
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1.5">
                  Şifre
                </label>
                <div className="relative">
                  <div className="absolute left-3.5 top-1/2 -translate-y-1/2 w-5 h-5 flex items-center justify-center text-gray-400">
                    <i className="ri-lock-line text-base"></i>
                  </div>
                  <input
                    type={showPassword ? "text" : "password"}
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    placeholder="Şifrenizi girin"
                    className="w-full pl-10 pr-12 py-3 text-sm border border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-[#25D366]/30 focus:border-[#25D366] bg-gray-50 transition-all"
                  />
                  <button
                    type="button"
                    onClick={() => setShowPassword(!showPassword)}
                    className="absolute right-3.5 top-1/2 -translate-y-1/2 w-5 h-5 flex items-center justify-center text-gray-400 hover:text-gray-600 cursor-pointer"
                  >
                    <i className={`${showPassword ? "ri-eye-off-line" : "ri-eye-line"} text-base`}></i>
                  </button>
                </div>
              </div>

              {error && (
                <div className="flex items-center gap-2 p-3 bg-red-50 rounded-xl border border-red-100">
                  <div className="w-4 h-4 flex items-center justify-center text-red-500">
                    <i className="ri-error-warning-line text-sm"></i>
                  </div>
                  <p className="text-xs text-red-600">{error}</p>
                </div>
              )}

              <button
                type="submit"
                disabled={loading}
                className="w-full py-3 px-6 bg-[#0B1120] text-white text-sm font-semibold rounded-xl hover:bg-[#1a2a4a] transition-all cursor-pointer disabled:opacity-70 whitespace-nowrap flex items-center justify-center gap-2"
              >
                {loading ? (
                  <>
                    <i className="ri-loader-4-line animate-spin text-base"></i>
                    <span>Giriş yapılıyor...</span>
                  </>
                ) : (
                  <>
                    <span>Panele Giriş Yap</span>
                    <i className="ri-arrow-right-line text-base"></i>
                  </>
                )}
              </button>
            </form>

            {/* Demo info */}
            <div className="mt-6 p-3 bg-gray-50 rounded-xl border border-gray-100">
              <p className="text-xs text-gray-500 text-center">
                <span className="font-medium text-gray-700">Demo modu:</span> Herhangi bir kullanıcı adı ve şifre ile giriş yapabilirsiniz.
              </p>
            </div>
          </div>

          {/* Features */}
          <div className="mt-6 grid grid-cols-3 gap-3">
            {[
              { icon: "ri-shield-check-line", label: "Güvenli" },
              { icon: "ri-whatsapp-line", label: "WhatsApp Entegre" },
              { icon: "ri-smartphone-line", label: "Mobil Uyumlu" },
            ].map((f, i) => (
              <div key={i} className="flex flex-col items-center gap-1.5 p-3 bg-white rounded-xl border border-gray-100">
                <div className="w-7 h-7 flex items-center justify-center text-[#25D366]">
                  <i className={`${f.icon} text-lg`}></i>
                </div>
                <span className="text-xs text-gray-500 text-center">{f.label}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}